import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import "../../Assets/CSS/CreateNewProject.css";
import { Icon } from "@iconify/react";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const CreateNewProject = () => {
  const navigate = useNavigate();
  // const owners = ["Ram", "Shyam", "Rohit", "Priya"];

  const [selectedTeams, setSelectedTeams] = useState([]);
  console.log(selectedTeams, "seleced team");
  const [teamList, setTeamsList] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/teams`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(`${process.env.REACT_APP_BACKEND_URL}/teams`);
        setTeamsList(response?.data?.content);
        console.log(response?.data?.content, "datateam");
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, []);


  const formatDate = (date) => {
    if (!date) return null;
    return new Date(date).toISOString().split("T")[0]; // "YYYY-MM-DD"
  };

  // ==============================
  // MAIN FORM STATE
  // ==============================
  const [formData, setFormData] = useState({
    projectName: "",
    // owner: "",
    teamIds: [],
    projectDescription: "",
    startDate: null,
    endDate: null,
  });
  // Validation errors
  const [errors, setErrors] = useState({});

  // =======================
  // DATE RANGE LOGIC (INSIDE SAME FILE)
  // =======================
  const [open, setOpen] = useState(false);

  const [tempRange, setTempRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [finalRange, setFinalRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const formatRange = () => {
    return (
      format(finalRange[0].startDate, "dd MMM ''yy") +
      " - " +
      format(finalRange[0].endDate, "dd MMM ''yy")
    );
  };

  // const handleApply = () => {
  //   setFinalRange(tempRange);
  //   setOpen(false);
  // };

  const handleApply = () => {
    setFinalRange(tempRange);

    setFormData({
      ...formData,
      startDate: tempRange[0].startDate,
      endDate: tempRange[0].endDate,
    });

    setErrors({
      ...errors,
      dateRange: "", // remove error
    });

    setOpen(false);
  };

  const handleClear = () => {
    const reset = [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ];
    setTempRange(reset);
    setFinalRange(reset);
    setOpen(false);
  };

  // =======================

  const handleTeamSelect = (teamId) => {
    const teamObj = teamList.find((t) => t.teamId === teamId);
    if (!teamObj) return; // safeguard if not found

    if (!selectedTeams.some((t) => t.id === teamId)) {
      const updated = [
        ...selectedTeams,
        { id: teamId, name: teamObj.teamName },
      ];
      setSelectedTeams(updated);

      // Update formData with just IDs
      setFormData({ ...formData, teamIds: updated.map((t) => t.id) });
      setErrors({ ...errors, teamIds: "" });
    }
  };

  const removeTeam = (teamId) => {
    const updated = selectedTeams.filter((t) => t.id !== teamId);
    setSelectedTeams(updated);

    // Update formData with just IDs
    setFormData({ ...formData, teamIds: updated.map((t) => t.id) });
  };

  // ==============================
  // VALIDATION + SUBMIT
  // ==============================
  const validate = () => {
    let temp = {};

    if (!formData.projectName.trim())
      temp.projectName = "Project Name is required";
    // if (!formData.owner) temp.owner = "Owner is required";
    if (formData.teamIds.length === 0)
      temp.teamIds = "Select at least one team member";
    if (!formData.projectDescription.trim())
      temp.projectDescription = "Description is required";
    if (!formData.startDate || !formData.endDate) {
      temp.dateRange = "Please select a date range";
    }

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    const payload = {
      ...formData,
      startDate: formatDate(formData.startDate),
      endDate: formatDate(formData.endDate),
    };


    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/projects`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Project created successfully!");
      navigate("/projecttrack");
    } catch (error) {
      console.error("Error creating team:", error);
      toast.error(error?.message);
    }
  };

  // ==============================

  const labelcss = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "12px",
    color: "#606060",
  };

  return (
    <Layout>
      <div className="backgound-main-content">
        <div className="p-2">
          <p
            style={{
              fontSize: "22px",
              fontWeight: "600",
              color: "#303030",
              padding: "0px",
              margin: "0px",
            }}
          >
            Create New Project
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#909090",
              fontFamily: "400",
              padding: "0px",
              margin: "0px",
              marginTop: "10px",
            }}
          >
            Enter following details to start new project.
          </p>
        </div>

        <div className="form-section">
          {/* PROJECT TITLE */}
          <div className="form-group col-10">
            <label className="label" style={{ ...labelcss }}>
              Project Name<span>*</span>
            </label>
            <input
              type="text"
              className="form-control input-box"
              placeholder="Enter project name"
              onChange={(e) => {
                setFormData({ ...formData, projectName: e.target.value });
                setErrors({ ...errors, projectName: "" });
              }}
            />
            {errors.projectName && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "2px",
                  marginBottom: "0px",
                }}
              >
                {errors.projectName}
              </p>
            )}
          </div>

          {/* OWNER + DATE RANGE */}
          <div className="row">
            {/* OWNER */}
            {/* <div className="col-5 ">
              <label className="label" style={{ ...labelcss }}>
                Owner<span>*</span>
              </label>
              <select
                className="form-select input-box"
                onChange={(e) => {
                  setFormData({ ...formData, owner: e.target.value });
                  setErrors({ ...errors, owner: "" });
                }}
              >
                <option>Select team member</option>
                {owners.map((o) => (
                  <option key={o}>{o}</option>
                ))}
              </select>
              {errors.owner && (
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "2px",
                    marginBottom: "0px",
                  }}
                >
                  {errors.owner}
                </p>
              )}
            </div> */}

            {/* DATE RANGE */}
            <div className="col-5" style={{ position: "relative" }}>
              <label className="label" style={{ ...labelcss }}>
                Due Date<span>*</span>
              </label>

              <div
                className="form-control input-box d-flex align-items-center justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() => setOpen(!open)}
              >
                <span>{formatRange()}</span>
                <Icon icon="mdi:calendar-month" width="22" color="#00AEEF" />
              </div>
              {errors.dateRange && (
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "2px",
                    marginBottom: "0px",
                  }}
                >
                  {errors.dateRange}
                </p>
              )}
              {open && (
                <div
                  style={{
                    position: "absolute",
                    top: "55px",
                    zIndex: 20,
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  <DateRange
                    locale={enUS}
                    editableDateInputs={true}
                    moveRangeOnFirstSelection={false}
                    ranges={tempRange}
                    onChange={(item) => setTempRange([item.selection])}
                  />

                  {/* CLEAR + APPLY BUTTONS */}
                  <div
                    className="d-flex justify-content-between p-2"
                    style={{ borderTop: "1px solid #ddd" }}
                  >
                    <button className="btn btn-light" onClick={handleClear}>
                      Clear
                    </button>

                    <button
                      className="btn btn-primary"
                      onClick={handleApply}
                      style={{
                        backgroundColor: "#00AEEF",
                        border: "none",
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* TEAM SELECT */}
          <div className="form-group col-5 p-1">
            <label className="label" style={{ ...labelcss }}>
              Pick team members<span>*</span>
            </label>

            <select
              className="form-select input-box"
              onChange={(e) => handleTeamSelect(Number(e.target.value))}
            >
              <option value="">Select team</option>
              {teamList?.map((team) => (
                <option key={team.teamId} value={team.teamId}>
                  {team.teamName}
                </option>
              ))}
            </select>
            {errors.teamId && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "2px",
                  marginBottom: "0px",
                }}
              >
                {errors.teamId}
              </p>
            )}

            <div className="chips-container">
              {selectedTeams.map((team) => (
                <span className="chip" key={team}>
                  {team?.name}
                  <span
                    className="remove-chip"
                    onClick={() => removeTeam(team.id)}
                  >
                    ×
                  </span>
                </span>
              ))}
            </div>
          </div>

          {/* DESCRIPTION */}
          <div className="form-group col-10">
            <label className="label">
              Description<span>*</span>
            </label>
            <textarea
              className="form-control textarea-box"
              placeholder="Enter description"
              onChange={(e) => {
                setFormData({
                  ...formData,
                  projectDescription: e.target.value,
                });
                setErrors({ ...errors, projectDescription: "" });
              }}
            ></textarea>
            {errors.projectDescription && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "2px",
                  marginBottom: "0px",
                }}
              >
                {errors.projectDescription}
              </p>
            )}
          </div>

          {/* BUTTONS */}
          <div className="d-flex gap-5 mt-4">
            <button
              className="cancel-button-project"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button className="create-button-project" onClick={handleSubmit}>
              <Icon icon="mdi:plus" /> Create Project
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CreateNewProject;
